import React from "react"
import CountUp from "react-countup"
import VisibilitySensor from "react-visibility-sensor"

export function StatContainer({ children, classes }) {
  return (
    <div className={classes ? `stat-container ${classes}` : `stat-container`}>
      {children}
    </div>
  )
}

export function Stat({
  prefix,
  suffix,
  number,
  unit,
  note,
  preamble,
  children,
  text,
  style,
  color,
}) {
  return (
    <div
      className="stat"
      key={`stat${Math.random()}`}
      style={style ? style : null}
    >
      {children && <div className="stat__icon">{children}</div>}
      <div className="stat__text-section">
        {preamble && <div className="stat__note">{preamble}</div>}

        {number && (
          <VisibilitySensor>
            {({ isVisible }) => (
              <CountUp
                end={number}
                duration={1.5}
                start={isVisible}
                delay={0}
                prefix={prefix !== undefined ? prefix : ""}
                suffix={suffix !== undefined ? suffix : ""}
                separator=","
              >
                {({ countUpRef }) => (
                  <div
                    className={`stat__number ${color && `color--${color}`}`}
                    ref={countUpRef}
                  />
                )}
              </CountUp>
            )}
          </VisibilitySensor>
        )}

        {text && (
          <div className={`stat__text ${color && `color--${color}`}`}>
            {text}
          </div>
        )}
        {unit && <div className="stat__unit">{unit}</div>}
        {note && <div className="stat__note">{note}</div>}
      </div>
    </div>
  )
}
